import { jsx as _jsx } from "react/jsx-runtime";
import { unescapeReferenceToken } from '@criteria/json-pointer';
import { APIView, operationsFromAPI } from '../../api-view';
import { OperationList, OperationListItem } from '../../operation-list';
import { SchemaView } from '../../schema-view';
export function DocsView({ api, location }) {
    var _a, _b, _c, _d;
    if (typeof location === 'string' && location.startsWith('#')) {
        if (location.startsWith('#/')) {
            let match = location.match(/^#\/paths\/(~1[^/]*)\/(get|put|post|delete|options|head|patch|trace)(|\/.*)$/);
            if (match !== null) {
                const path = unescapeReferenceToken(match[1]);
                const method = match[2];
                const pathItem = ((_a = api.paths) !== null && _a !== void 0 ? _a : {})[path];
                const operation = (pathItem !== null && pathItem !== void 0 ? pathItem : {})[method];
                if (operation) {
                    return _jsx(OperationListItem, { path: path, pathItem: pathItem, method: method, operation: operation });
                }
            }
            match = location.match(/^#\/components\/schemas\/([^/]*)$/);
            if (match !== null) {
                const schemaName = unescapeReferenceToken(match[1]);
                const schema = ((_c = ((_b = api.components) !== null && _b !== void 0 ? _b : {}).schemas) !== null && _c !== void 0 ? _c : {})[schemaName];
                if (typeof schema === 'object' || typeof schema === 'boolean') {
                    return _jsx(SchemaView, { schema: schema });
                }
            }
            match = location.match(/^#\/x-tagsByName\/([^/]*)$/);
            if (match !== null) {
                const tagName = unescapeReferenceToken(match[1]);
                const tag = ((_d = api.tags) !== null && _d !== void 0 ? _d : []).find((tag) => tag.name === tagName);
                if (tag) {
                    const operations = operationsFromAPI(api).filter(([, , , operation]) => { var _a; return ((_a = operation.tags) !== null && _a !== void 0 ? _a : []).includes(tagName); });
                    return _jsx(OperationList, { operations: operations });
                }
            }
        }
        else {
            const operationId = location.slice(1);
            const operations = operationsFromAPI(api);
            for (const [path, pathItem, method, operation] of operations) {
                if (operation.operationId === operationId) {
                    return _jsx(OperationListItem, { path: path, pathItem: pathItem, method: method, operation: operation });
                }
            }
        }
    }
    return _jsx(APIView, { api: api });
}
